"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.slotTypes = void 0;
exports.slotTypes = [
    {
        name: 'issuetype',
        description: 'Types of issues that can be reported',
        enumerationValues: [
            {
                value: 'housing violation',
                synonyms: ['many people living in', 'too many people living']
            },
            {
                value: 'water leak'
            },
            {
                value: 'broken sidewalk',
                synonyms: [
                    'broken side walk',
                    'sidewalk repair',
                    'sidewalk missing',
                    'missing sidewalk',
                    'hole in sidewalk'
                ]
            },
            {
                value: 'pothole',
                synonyms: ['pot hole', 'hole']
            },
            {
                value: 'storm drainage issue',
                synonyms: ['storm drain', 'drain', 'drainage', 'storm drainage', 'not draining']
            },
            {
                value: 'zoning violation'
            },
            {
                value: 'car accident',
                synonyms: ['accident']
            },
            {
                value: 'clogged storm drain',
                synonyms: ['drain is clogged', 'drains are clogged']
            },
            {
                value: 'wrecked vehicle',
                synonyms: ['crashed car']
            },
            {
                value: 'noise violation',
                synonyms: [
                    'so much noise',
                    'a lot noise',
                    'noisy',
                    'loud noise',
                    'dog barking',
                    'barking dog',
                    'dog does not stop barking',
                    'neighbor is being loud',
                    'neighbor is making loud noise',
                    "neighbor's dog barking"
                ]
            },
            {
                value: 'litter on the road',
                synonyms: [
                    'litter',
                    'litter on road',
                    'litter on sidewalk',
                    'litter on property',
                    'littering'
                ]
            },
            {
                value: 'water pollution'
            },
            {
                value: 'sewer backup',
                synonyms: [
                    'sewer is not draining',
                    'sewer is clogged',
                    'clogged sewer',
                    'sewage',
                    'sewage smell'
                ]
            },
            {
                value: 'potholes',
                synonyms: ['pot holes', 'holes']
            },
            {
                value: 'broken Street Sign',
                synonyms: [
                    'stop sign',
                    'sign that is broken',
                    'broken sign',
                    'ran over the street sign',
                    'hit the street sign',
                    'sign is broken',
                    'hit the sign',
                    'broken stop sign'
                ]
            },
            {
                value: 'mosquitos'
            },
            {
                value: 'sinkhole',
                synonyms: ['sink hole', 'sinkholes', 'sink holes']
            },
            {
                value: 'fallen tree',
                synonyms: [
                    'tree',
                    'broken tree',
                    'tree has fallen',
                    'tree fell',
                    'tree fell on street',
                    'tree fell on highway'
                ]
            },
            {
                value: 'flooded street',
                synonyms: ['flooding', 'water in street', 'flood', 'completely flooded']
            },
            {
                value: 'broken street light'
            },
            {
                value: 'dead animal',
                synonyms: ['dead', 'dead dog', 'dead rat', 'dead bird']
            },
            {
                value: 'debris'
            },
            {
                value: 'graffiti',
                synonyms: ['drawing', 'painted graffiti', 'someone has painted']
            },
            {
                value: 'broken fire hydrant',
                synonyms: ['fire hydrant is broken']
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        protected: true
    },
    {
        name: 'DescribeDamage',
        enumerationValues: [
            {
                value: 'broken lid',
                synonyms: ['the lid is broken', 'lid is broken', 'lid is damaged']
            },
            {
                value: 'broken',
                synonyms: ['it is broken', 'broken very badly']
            },
            {
                value: 'badly damaged',
                synonyms: ['it is completely damaged', 'very badly damaged']
            },
            {
                value: 'none',
                synonyms: [
                    'NO',
                    'No',
                    'nO',
                    'nope',
                    'na',
                    'n',
                    'N',
                    'its not',
                    'i dont think so',
                    'it is slolen',
                    'stolen can',
                    'it got stolen',
                    'stolen container'
                ]
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        description: '',
        protected: true
    },
    {
        name: 'cb_trash_synonym_slot',
        description: 'Synonyms for trash',
        enumerationValues: [
            {
                value: 'bulky item',
                synonyms: ['large item']
            },
            {
                value: 'mattress'
            },
            {
                value: 'recycling',
                synonyms: ['recycle']
            },
            {
                value: 'garbage'
            },
            {
                value: 'couch',
                synonyms: ['sofa']
            },
            {
                value: 'yard waste',
                synonyms: ['debris', 'yard trash']
            },
            {
                value: 'dumpster'
            },
            {
                value: 'trash',
                synonyms: ['trash can']
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        protected: true
    },
    {
        name: 'cb_search_replace_item_slot',
        enumerationValues: [
            {
                value: 'traffic ticket'
            },
            {
                value: 'license'
            },
            {
                value: 'parking ticket'
            },
            {
                value: 'warrent'
            }
        ],
        valueSelectionStrategy: 'ORIGINAL_VALUE',
        description: '',
        protected: true
    },
    {
        name: 'SewageRequestType',
        enumerationValues: [
            {
                value: 'backup'
            },
            {
                value: 'overflow from the main'
            },
            {
                value: 'cleanout cap is missing'
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        description: '',
        protected: true
    },
    {
        name: 'cb_smalltalk_topic',
        description: 'A few expected topics',
        enumerationValues: [
            {
                value: 'the election'
            },
            {
                value: 'the weather'
            },
            {
                value: 'traffic'
            }
        ],
        valueSelectionStrategy: 'ORIGINAL_VALUE',
        protected: true
    },
    {
        name: 'FW_cave_in_phrase',
        description: 'Ways to say cavein',
        enumerationValues: [
            {
                value: 'sinking ground',
                synonyms: ['sinking pavement', 'pavement sinking', 'ground sinking']
            },
            {
                value: 'cave-in',
                synonyms: ['cavein', 'cave in', 'caving in']
            },
            {
                value: 'sink hole',
                synonyms: ['sinkhole']
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        protected: true
    },
    {
        name: 'cb_yard_nouns_slot',
        enumerationValues: [
            {
                value: 'boxes'
            },
            {
                value: 'yard'
            },
            {
                value: 'limbs'
            },
            {
                value: 'bush',
                synonyms: ['bushes']
            },
            {
                value: 'tree',
                synonyms: ['trees']
            },
            {
                value: 'pool'
            },
            {
                value: 'lot'
            },
            {
                value: 'engine'
            },
            {
                value: 'furniture'
            },
            {
                value: 'grass'
            },
            {
                value: 'junk'
            },
            {
                value: 'debris'
            },
            {
                value: 'weeds',
                synonyms: ['weed']
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        description: '',
        protected: true
    },
    {
        name: 'UsersResidence',
        description: 'Places to describe users residence',
        enumerationValues: [
            {
                value: 'my neighbors house',
                synonyms: ['my neighbors yard']
            },
            {
                value: 'my neighborhood'
            },
            {
                value: 'next door'
            },
            {
                value: 'my home'
            },
            {
                value: 'my house'
            },
            {
                value: 'my neighbors home'
            },
            {
                value: 'my street'
            },
            {
                value: 'where I live'
            },
            {
                value: 'my place'
            },
            {
                value: 'my block'
            },
            {
                value: 'my road'
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        protected: true
    },
    {
        name: 'IssuTypeDamageProperty',
        enumerationValues: [
            {
                value: 'mattress'
            },
            {
                value: 'pothole',
                synonyms: ['potholes']
            },
            {
                value: 'litter'
            },
            {
                value: 'manhole cover'
            },
            {
                value: 'blinking',
                synonyms: ['flashing']
            },
            {
                value: 'rough surface'
            },
            {
                value: 'rough patch'
            },
            {
                value: 'traffic signal malfunction'
            },
            {
                value: 'street light wrecked'
            },
            {
                value: 'malfunction',
                synonyms: ['outage']
            },
            {
                value: 'street light broke',
                synonyms: ['streetlight broke']
            },
            {
                value: 'street signal',
                synonyms: ['traffic light', 'traffic signal']
            },
            {
                value: 'road surface marking'
            },
            {
                value: 'manhole'
            },
            {
                value: 'street light outage'
            },
            {
                value: 'street light malfunction'
            },
            {
                value: 'debris'
            },
            {
                value: 'cable'
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        description: '',
        protected: true
    },
    {
        name: 'bulkyItems',
        description: 'Realted to bulky items',
        enumerationValues: [
            {
                value: 'bulk item',
                synonyms: ['bulky items', 'bulk items', 'bulky items', 'bulk']
            }
        ],
        valueSelectionStrategy: 'ORIGINAL_VALUE',
        protected: true
    },
    {
        name: 'DamageDescribe',
        enumerationValues: [
            {
                value: 'it is completely damaged'
            },
            {
                value: 'very badly damaged'
            },
            {
                value: 'lid is broken'
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        description: '',
        protected: true
    },
    {
        name: 'DamageAdjective',
        description: 'Describes the damage',
        enumerationValues: [
            {
                value: 'small',
                synonyms: ['little', 'slight']
            },
            {
                value: 'too many',
                synonyms: ['a lot']
            },
            {
                value: 'big',
                synonyms: ['huge', 'giant']
            },
            {
                value: 'deep'
            },
            {
                value: 'still'
            },
            {
                value: 'major'
            },
            {
                value: 'minor'
            },
            {
                value: 'more'
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        protected: true
    },
    {
        name: 'cb_recycle_synonym_slot',
        description: 'Recycling term synonyms',
        enumerationValues: [
            {
                value: 'recycle',
                synonyms: ['recycling']
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        protected: true
    },
    {
        name: 'DurationOfTime',
        description: 'How long the issue has been happening',
        enumerationValues: [
            {
                value: 'since last month'
            },
            {
                value: 'since last week'
            },
            {
                value: 'for a few days'
            },
            {
                value: 'for a couple weeks'
            },
            {
                value: 'for a month'
            },
            {
                value: 'for a while'
            },
            {
                value: 'for a few hours'
            },
            {
                value: 'for over 24 hours'
            },
            {
                value: 'for a week'
            },
            {
                value: 'for a couple days'
            },
            {
                value: 'for over a month'
            },
            {
                value: 'for over a week'
            },
            {
                value: 'since yesterday'
            }
        ],
        valueSelectionStrategy: 'ORIGINAL_VALUE',
        protected: true
    },
    {
        name: 'CurbsideConfirmation',
        enumerationValues: [
            {
                value: 'No'
            },
            {
                value: 'Yes'
            }
        ],
        valueSelectionStrategy: 'ORIGINAL_VALUE',
        description: '',
        protected: true
    },
    {
        name: 'cb_license_service_type_slot',
        description: 'Types of licenses users might need info about',
        enumerationValues: [
            {
                value: 'business'
            },
            {
                value: 'proclamation'
            },
            {
                value: 'marriage'
            },
            {
                value: 'birth certificate'
            }
        ],
        valueSelectionStrategy: 'ORIGINAL_VALUE',
        protected: true
    },
    {
        name: 'AppointmentTypeValue',
        description: 'Type of dentist appointment to schedule',
        enumerationValues: [
            {
                value: 'cleaning'
            },
            {
                value: 'whitening'
            },
            {
                value: 'root canal'
            }
        ],
        valueSelectionStrategy: undefined,
        protected: true
    },
    {
        name: 'ProximityDescription',
        description: 'Describes words near a location',
        enumerationValues: [
            {
                value: 'the edge',
                synonyms: ['the edge of']
            },
            {
                value: 'the intersection',
                synonyms: [
                    'the cross street',
                    'the cross street of',
                    'the cross streets',
                    'the cross streets of',
                    'the intersection of'
                ]
            },
            {
                value: 'the street',
                synonyms: ['the street of', 'the road']
            },
            {
                value: 'the end',
                synonyms: ['the end of']
            },
            {
                value: 'the corner',
                synonyms: ['the corner of']
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        protected: true
    },
    {
        name: 'cb_search_action_slot',
        description: 'Types of user-initiated actions a user might want more info about',
        enumerationValues: [
            {
                value: 'request'
            },
            {
                value: 'sign wedding certificate'
            },
            {
                value: 'reserve a park'
            },
            {
                value: 'move my car'
            },
            {
                value: 'find'
            },
            {
                value: 'buy bus pass'
            },
            {
                value: 'get'
            },
            {
                value: 'recycle'
            },
            {
                value: 'reserve a clubhouse'
            },
            {
                value: 'put'
            }
        ],
        valueSelectionStrategy: 'ORIGINAL_VALUE',
        protected: true
    },
    {
        name: 'vehicleType',
        description: 'vehicle model (f-150, civic, etc.)',
        enumerationValues: [
            {
                value: 'car',
                synonyms: ['junk car']
            },
            {
                value: 'suv'
            },
            {
                value: 'truck',
                synonyms: [
                    'f150',
                    'f250',
                    'f350',
                    'ram1500',
                    'ram2500',
                    'silverado',
                    'tacoma',
                    'frontier',
                    'tundra',
                    'sierra',
                    'box truck'
                ]
            },
            {
                value: '18 wheeler',
                synonyms: ['semi truck', 'semi']
            },
            {
                value: 'sedan'
            },
            {
                value: '16 wheeler'
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        protected: true
    },
    {
        name: 'cb_damaged_property_slot',
        description: "If a person's claiming the city damaged their property, these are expected types",
        enumerationValues: [
            {
                value: 'ceiling'
            },
            {
                value: 'roof',
                synonyms: ['the roof']
            },
            {
                value: 'mailbox'
            },
            {
                value: 'air conditioning',
                synonyms: ['a/c', 'ac']
            },
            {
                value: 'car'
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        protected: true
    },
    {
        name: 'ContainerLocation',
        enumerationValues: [
            {
                value: 'Curbside',
                synonyms: ['curbside']
            },
            {
                value: 'Backyard',
                synonyms: ['backyard']
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        description: '',
        protected: true
    },
    {
        name: 'color_slot_type',
        description: 'Actual colors instead of Amazon.Color',
        enumerationValues: [
            {
                value: 'pink'
            },
            {
                value: 'green'
            },
            {
                value: 'black'
            },
            {
                value: 'yellow'
            },
            {
                value: 'brown'
            },
            {
                value: 'grey',
                synonyms: ['gray']
            },
            {
                value: 'bronze',
                synonyms: ['brass']
            },
            {
                value: 'red'
            },
            {
                value: 'orange'
            },
            {
                value: 'gold'
            },
            {
                value: 'blue'
            },
            {
                value: 'white'
            },
            {
                value: 'purple'
            },
            {
                value: 'silver'
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        protected: true
    },
    {
        name: 'ConfirmCurbside',
        enumerationValues: [
            {
                value: 'curbside',
                synonyms: ['Curbside']
            },
            {
                value: 'backyard',
                synonyms: ['Backyard']
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        description: '',
        protected: true
    },
    {
        name: 'cb_search_service_fallback_slot',
        description: "Certain services aren't being caught by the builtin service slot",
        enumerationValues: [
            {
                value: 'FOIA'
            },
            {
                value: 'license'
            },
            {
                value: 'freedom of information'
            },
            {
                value: 'trash days'
            },
            {
                value: 'post office'
            },
            {
                value: 'spray zone'
            },
            {
                value: 'recycling'
            },
            {
                value: 'postal office'
            },
            {
                value: 'building permit'
            },
            {
                value: 'street sweeping'
            },
            {
                value: 'mosquito spray'
            },
            {
                value: 'inspection'
            }
        ],
        valueSelectionStrategy: 'ORIGINAL_VALUE',
        protected: true
    },
    {
        name: 'vehicleMake',
        description: 'make of vehicle',
        enumerationValues: [
            {
                value: 'dodge'
            },
            {
                value: 'accura'
            },
            {
                value: 'buick'
            },
            {
                value: 'cheverlot',
                synonyms: ['chevy']
            },
            {
                value: 'honda'
            },
            {
                value: 'ford'
            },
            {
                value: 'oldsmobile'
            },
            {
                value: 'ferrarri'
            },
            {
                value: 'bmw'
            },
            {
                value: 'range rover'
            },
            {
                value: 'volkswagen',
                synonyms: ['volkswagen bus', 'vw', 'vw bus']
            },
            {
                value: 'toyota'
            },
            {
                value: 'nissan'
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        protected: true
    },
    {
        name: 'traffic_issue',
        description: 'describes traffic issue',
        enumerationValues: [
            {
                value: 'stopped'
            },
            {
                value: 'backed up'
            },
            {
                value: 'calming'
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        protected: true
    },
    {
        name: 'IssueOpening',
        description: 'Different ways a user may open a report message',
        enumerationValues: [
            {
                value: 'there are'
            },
            {
                value: 'a'
            },
            {
                value: 'repair',
                synonyms: ['repair the']
            },
            {
                value: 'check out the'
            },
            {
                value: 'why',
                synonyms: ['why is the', 'why is there', 'why are there']
            },
            {
                value: 'the'
            },
            {
                value: 'fix',
                synonyms: ['can you fix', 'can you fix the', 'fix the', 'i need']
            },
            {
                value: 'someone',
                synonyms: ['someone left', 'someone left a', 'someone left an']
            },
            {
                value: 'there was'
            },
            {
                value: 'i need a',
                synonyms: ['need a']
            },
            {
                value: 'report',
                synonyms: ['i want to report', 'I want to report', 'report a', 'reporting']
            },
            {
                value: 'there is',
                synonyms: [
                    'there is another',
                    "there's",
                    'theres',
                    "there's a",
                    'there is an',
                    "there's an"
                ]
            },
            {
                value: 'there is a',
                synonyms: ["There's a"]
            },
            {
                value: 'the property at'
            },
            {
                value: 'after our last',
                synonyms: ['after the last', 'since the last']
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        protected: true
    },
    {
        name: 'replacement_reason',
        description: 'Reason for recycling bin or trash can replacement',
        enumerationValues: [
            {
                value: 'damaged can report',
                synonyms: ['damaged', 'broken', "doesn't work"]
            },
            {
                value: 'pickup old can',
                synonyms: ['old can', 'old']
            },
            {
                value: 'new can request',
                synonyms: ['new can', 'new bin', 'new trash can', 'new recycling bin']
            },
            {
                value: 'stolen can report',
                synonyms: ['stolen', 'lost', 'missing', 'someone stole it', 'someone stole mine']
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        protected: true
    },
    {
        name: 'rightOfWay',
        description: 'Litter removal, mowing, trimming',
        enumerationValues: [
            {
                value: 'litter',
                synonyms: ['litter removal']
            },
            {
                value: 'mowing',
                synonyms: ['grass mowing', 'weed mowing']
            },
            {
                value: 'trimming',
                synonyms: ['tree trimming', 'branch cutoff']
            }
        ],
        valueSelectionStrategy: 'ORIGINAL_VALUE',
        protected: true
    },
    {
        name: 'BulkItemYesNo',
        enumerationValues: [
            {
                value: 'No'
            },
            {
                value: 'Yes'
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        description: '',
        protected: true
    },
    {
        name: 'vehicleIssue',
        enumerationValues: [
            {
                value: 'parking'
            },
            {
                value: 'nuisance'
            },
            {
                value: 'broken down',
                synonyms: ['smoking', 'on fire']
            },
            {
                value: 'abandoned'
            },
            {
                value: 'body damage',
                synonyms: ['major body damage']
            },
            {
                value: 'illegal parking',
                synonyms: ['parked in yard']
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        description: '',
        protected: true
    },
    {
        name: 'claim_issue',
        enumerationValues: [
            {
                value: 'hole'
            },
            {
                value: 'leaking'
            },
            {
                value: 'out'
            }
        ],
        valueSelectionStrategy: 'ORIGINAL_VALUE',
        description: '',
        protected: true
    },
    {
        name: 'kindness_description',
        enumerationValues: [
            {
                value: 'polite'
            },
            {
                value: 'kindness'
            }
        ],
        valueSelectionStrategy: 'ORIGINAL_VALUE',
        description: '',
        protected: true
    },
    {
        name: 'cb_trash_container_noun',
        description: 'Types of trash containers',
        enumerationValues: [
            {
                value: 'container'
            },
            {
                value: 'can'
            },
            {
                value: 'bin'
            },
            {
                value: 'cart'
            },
            {
                value: 'receptical'
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        protected: true
    },
    {
        name: 'AnimalOnPrivProp',
        enumerationValues: [
            {
                value: 'no'
            },
            {
                value: 'yes'
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        description: '',
        protected: true
    },
    {
        name: 'recycling_phrase',
        enumerationValues: [
            {
                value: 'recycle',
                synonyms: ['recycling', 'recycling bin']
            }
        ],
        valueSelectionStrategy: 'ORIGINAL_VALUE',
        description: '',
        protected: true
    },
    {
        name: 'yardWaste',
        description: 'Yard related waste items',
        enumerationValues: [
            {
                value: 'grass clippings'
            },
            {
                value: 'bush'
            },
            {
                value: 'dead flowers and plants'
            },
            {
                value: 'tree trunks'
            },
            {
                value: 'Christmas trees'
            },
            {
                value: 'leaves'
            },
            {
                value: 'rocks'
            },
            {
                value: 'wood shavings'
            },
            {
                value: 'pruned branches and stems'
            },
            {
                value: 'dirt'
            },
            {
                value: 'weeds'
            },
            {
                value: 'roots'
            }
        ],
        valueSelectionStrategy: 'ORIGINAL_VALUE',
        protected: true
    },
    {
        name: 'ReplacementReason',
        enumerationValues: [
            {
                value: 'Damaged'
            },
            {
                value: 'Stolen'
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        description: '',
        protected: true
    },
    {
        name: 'hazard_material_type',
        enumerationValues: [
            {
                value: 'oil'
            },
            {
                value: 'paint'
            },
            {
                value: 'tire'
            },
            {
                value: 'tires'
            }
        ],
        valueSelectionStrategy: 'ORIGINAL_VALUE',
        description: '',
        protected: true
    },
    {
        name: 'ReplacementConfirmation',
        enumerationValues: [
            {
                value: 'Damaged'
            },
            {
                value: 'Stolen'
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        description: '',
        protected: true
    },
    {
        name: 'PublicPropertyType',
        description: 'Types of public property.',
        enumerationValues: [
            {
                value: 'freeway entrance'
            },
            {
                value: 'ditch'
            },
            {
                value: 'manhole cover',
                synonyms: ['manhole']
            },
            {
                value: 'sign',
                synonyms: ['traffic sign']
            },
            {
                value: 'parking lines',
                synonyms: ['parking spot', 'parking spots']
            },
            {
                value: 'crossing sign'
            },
            {
                value: 'parking meter'
            },
            {
                value: 'pole'
            },
            {
                value: 'curb'
            },
            {
                value: 'walking signal'
            },
            {
                value: 'school zone flashers',
                synonyms: ['school lights', 'school zone lights', 'school flashers']
            },
            {
                value: 'cross walk'
            },
            {
                value: 'building'
            },
            {
                value: 'lot'
            },
            {
                value: 'street markings'
            },
            {
                value: 'accessibility ramp',
                synonyms: ['accessibility ramps', 'handicap ramps', 'handicap ramp']
            },
            {
                value: 'signs'
            },
            {
                value: 'crosswalk'
            },
            {
                value: 'street signal',
                synonyms: [
                    'traffic signal',
                    'traffic signals',
                    'street signals',
                    'traffic light',
                    'traffic lights'
                ]
            },
            {
                value: 'road',
                synonyms: ['my road', 'the road']
            },
            {
                value: 'furniture'
            },
            {
                value: 'street',
                synonyms: ['my street', 'the street']
            },
            {
                value: 'fire hydrant',
                synonyms: ['hydrant']
            },
            {
                value: 'parking garage'
            },
            {
                value: 'light pole',
                synonyms: ['light post', 'light-post', 'lightpost']
            },
            {
                value: 'pipe',
                synonyms: ['pipes']
            },
            {
                value: 'shoulder',
                synonyms: ['road shoulder']
            },
            {
                value: 'signal'
            },
            {
                value: 'street traffic lines',
                synonyms: ['traffic lines', 'road lines']
            },
            {
                value: 'sidewalk',
                synonyms: ['side walk']
            },
            {
                value: 'stop light',
                synonyms: ['stoplight']
            },
            {
                value: 'stop sign'
            },
            {
                value: 'lamp'
            },
            {
                value: 'street sign'
            },
            {
                value: 'parking lot'
            },
            {
                value: 'crossing signal'
            },
            {
                value: 'driveway'
            },
            {
                value: 'street light',
                synonyms: ['streetlight', 'street lights', 'streetlights']
            },
            {
                value: 'light'
            },
            {
                value: 'street name sign',
                synonyms: ['road name sign']
            },
            {
                value: 'freeway exit'
            },
            {
                value: 'illegal signage',
                synonyms: ['illegal sign']
            },
            {
                value: 'roadway',
                synonyms: ['in roadway', 'the roadway']
            },
            {
                value: 'window'
            },
            {
                value: 'wall'
            },
            {
                value: 'fence'
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        protected: true
    },
    {
        name: 'emergency_type',
        description: 'Type of emergencies',
        enumerationValues: [
            {
                value: 'traffic signal',
                synonyms: ['traffic light']
            },
            {
                value: 'sewage'
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        protected: true
    },
    {
        name: 'cb_zoning_violation_type_slot',
        enumerationValues: [
            {
                value: 'shed'
            },
            {
                value: 'addition'
            },
            {
                value: 'air bnb'
            },
            {
                value: 'rental'
            }
        ],
        valueSelectionStrategy: 'ORIGINAL_VALUE',
        description: '',
        protected: true
    },
    {
        name: 'TenantConfirmation',
        enumerationValues: [
            {
                value: 'No'
            },
            {
                value: 'Yes'
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        description: '',
        protected: true
    },
    {
        name: 'ScheduledDay',
        enumerationValues: [
            {
                value: 'Monday',
                synonyms: ['monday', 'mon', 'start of the week', 'first day of the week']
            },
            {
                value: 'Tuesday',
                synonyms: ['tuesday', 'tue', 'second day of the week']
            },
            {
                value: 'Wednesday',
                synonyms: ['wednesday', 'wed', 'hump day', 'midweek']
            },
            {
                value: 'Thursday',
                synonyms: ['thursday', 'thu', 'thur', 'fourth day of the week']
            },
            {
                value: 'Friday',
                synonyms: ['friday', 'fri', 'end of the week', 'last working day']
            },
            {
                value: 'Saturday',
                synonyms: ['saturday', 'sat', 'first weekend day']
            },
            {
                value: 'Sunday',
                synonyms: ['sunday', 'sun', 'weekend', 'last day of the week', 'second weekend day']
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        description: '',
        protected: true
    },
    {
        name: 'vehicleColor',
        enumerationValues: [
            {
                value: 'red'
            },
            {
                value: 'green'
            },
            {
                value: 'blue'
            },
            {
                value: 'white'
            },
            {
                value: 'yellow'
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        description: '',
        protected: true
    },
    {
        name: 'isGangGraffiti',
        description: 'Grafffiti is related to gang or not',
        enumerationValues: [
            {
                value: 'no'
            },
            {
                value: 'maybe',
                synonyms: ["don't know", 'do not know', 'could be']
            },
            {
                value: 'yes'
            }
        ],
        valueSelectionStrategy: 'ORIGINAL_VALUE',
        protected: true
    },
    {
        name: 'IssueClosing',
        description: 'phrases that can be used at the end of an issue phrase.',
        enumerationValues: [
            {
                value: 'needs fixing',
                synonyms: [
                    'needs repair',
                    'needs to be repaired',
                    'needs to be fixed',
                    'should get fixed',
                    'fixed'
                ]
            },
            {
                value: 'are not working',
                synonyms: ["aren't working"]
            },
            {
                value: 'should be looked at'
            },
            {
                value: 'needs attention',
                synonyms: ['that needs attention']
            },
            {
                value: 'needs to be buried'
            },
            {
                value: 'the street',
                synonyms: ['the street of']
            },
            {
                value: 'dangerous',
                synonyms: ['causing a hazard', 'hazard', 'not safe']
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        protected: true
    },
    {
        name: 'Proximity',
        description: 'Proximity words',
        enumerationValues: [
            {
                value: 'close to'
            },
            {
                value: 'right around'
            },
            {
                value: 'in the middle of'
            },
            {
                value: 'in'
            },
            {
                value: 'inside'
            },
            {
                value: 'nearby'
            },
            {
                value: 'around'
            },
            {
                value: 'in the median'
            },
            {
                value: 'at'
            },
            {
                value: 'at the corner of'
            },
            {
                value: 'outside'
            },
            {
                value: 'in cul de sac'
            },
            {
                value: 'by'
            },
            {
                value: 'near'
            },
            {
                value: 'in front of'
            },
            {
                value: 'close by'
            },
            {
                value: 'next to'
            },
            {
                value: 'on'
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        protected: true
    },
    {
        name: 'requestType',
        enumerationValues: [
            {
                value: 'repainted',
                synonyms: ['painted']
            },
            {
                value: 'street sweeping',
                synonyms: ['street swept', 'streetsweeping']
            },
            {
                value: 'police record'
            },
            {
                value: 'speed bump'
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        description: '',
        protected: true
    },
    {
        name: 'issueInPark',
        description: 'Is the issue located in a park',
        enumerationValues: [
            {
                value: 'no',
                synonyms: ['nope', 'street']
            },
            {
                value: 'yes',
                synonyms: ['yep', 'park', 'playground', 'parks']
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        protected: true
    },
    {
        name: 'PublicDamageType',
        description: 'corresponding damage types',
        enumerationValues: [
            {
                value: 'unclean'
            },
            {
                value: 'clogged'
            },
            {
                value: 'not working',
                synonyms: ['broken', 'malfunctioning', 'malfunction']
            },
            {
                value: 'flashing red'
            },
            {
                value: 'powered off'
            },
            {
                value: 'out'
            },
            {
                value: 'backed up'
            },
            {
                value: 'blocked'
            },
            {
                value: 'pave'
            },
            {
                value: 'flashing',
                synonyms: ['blinking']
            },
            {
                value: 'missing'
            },
            {
                value: 'debris'
            },
            {
                value: 'on the ground'
            },
            {
                value: 'leaking'
            },
            {
                value: 'dirty'
            },
            {
                value: 'falling'
            },
            {
                value: 'faded'
            },
            {
                value: 'broke',
                synonyms: ['wrecked', 'wreck']
            },
            {
                value: 'messed up'
            },
            {
                value: 'bent'
            },
            {
                value: 'unstable'
            },
            {
                value: 'fallen'
            },
            {
                value: 'damaged',
                synonyms: ['damage']
            },
            {
                value: 'leaning'
            },
            {
                value: 'hanging'
            },
            {
                value: 'chipped'
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        protected: true
    },
    {
        name: 'blockingDriveway',
        description: 'Is the vehicle blocking a driveway?',
        enumerationValues: [
            {
                value: 'no',
                synonyms: ['nope', 'na', 'its not', 'i dont think so']
            },
            {
                value: 'yes',
                synonyms: ['yes', 'yep', 'it is', 'y', 'indeed']
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        protected: true
    },
    {
        name: 'PickupLocation',
        enumerationValues: [
            {
                value: 'curb middle of street'
            },
            {
                value: 'intersection'
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        description: '',
        protected: true
    },
    {
        name: 'ScheduledWeek',
        enumerationValues: [
            {
                value: 'Second'
            },
            {
                value: 'Third'
            },
            {
                value: 'Fourth'
            },
            {
                value: 'first'
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        description: '',
        protected: true
    },
    {
        name: 'DamageTypeWater',
        enumerationValues: [
            {
                value: 'broken'
            },
            {
                value: 'stopped'
            },
            {
                value: 'turned off'
            },
            {
                value: 'not working'
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        description: '',
        protected: true
    },
    {
        name: 'PropertyStatus',
        enumerationValues: [
            {
                value: 'Vaccant'
            },
            {
                value: 'Occupied'
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        description: '',
        protected: true
    },
    {
        name: 'citibot_yes_no',
        description: 'yes or no',
        enumerationValues: [
            {
                value: 'no',
                synonyms: ['NO', 'No', 'nO', 'nope', 'na', 'n', 'N', 'its not', 'i dont think so']
            },
            {
                value: 'yes',
                synonyms: [
                    'YES',
                    'yES',
                    'Yes',
                    'yEs',
                    'yES',
                    'YEs',
                    'si',
                    'y',
                    'of course',
                    'indeed',
                    'yep',
                    'Y',
                    'yes'
                ]
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        protected: true
    },
    {
        name: 'LocationType',
        enumerationValues: [
            {
                value: 'Multi-family location',
                synonyms: ['appartment']
            },
            {
                value: 'Single family location'
            },
            {
                value: 'Business location'
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        description: '',
        protected: true
    },
    {
        name: 'waterIssueType',
        enumerationValues: [
            {
                value: 'water meter',
                synonyms: ['meter box', 'water meter box', 'meter lid', 'meter box broken']
            },
            {
                value: 'water quality'
            },
            {
                value: 'water hydrant'
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        description: '',
        protected: true
    },
    {
        name: 'AnimalWeight',
        enumerationValues: [
            {
                value: 'no',
                synonyms: ['NO', 'No', 'nO', 'nope', 'na', 'n', 'N', 'its not', 'i dont think so']
            },
            {
                value: 'yes',
                synonyms: [
                    'YES',
                    'yES',
                    'Yes',
                    'yEs',
                    'yES',
                    'YEs',
                    'si',
                    'y',
                    'of course',
                    'indeed',
                    'yep',
                    'Y',
                    'yes'
                ]
            }
        ],
        valueSelectionStrategy: 'TOP_RESOLUTION',
        description: '',
        protected: true
    }
];
